import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function VerifyEmail() {
  const { token } = useParams();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState("verifying"); // verifying | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    (async () => {
      try {
        await api.post("/auth/email/verify", { token });
        setState("done");
        await refresh();
      } catch (err) {
        const d = err.response?.data?.detail;
        setMessage(typeof d === "string" ? d : "Verification failed");
        setState("error");
      }
    })();
  }, [token, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6 py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
        data-testid="verify-email-page"
      >
        <Link to="/" className="block text-center mb-12">
          <span className="font-display text-3xl tracking-tight text-gold">Wanted</span>
        </Link>
        <div className="glass-strong rounded-3xl p-10 text-center">
          {state === "verifying" && (
            <p className="text-gold-soft tracking-overline text-xs">VERIFYING YOUR EMAIL</p>
          )}
          {state === "done" && (
            <>
              <BadgeCheck className="mx-auto text-gold mb-6" size={36} fill="rgba(212,175,55,0.25)" />
              <div className="text-gold-soft tracking-overline text-xs mb-3">EMAIL VERIFIED</div>
              <h1 className="font-display text-3xl font-light mb-4">Welcome to Wanted.</h1>
              <p className="text-white/55 leading-relaxed mb-8">Your email is confirmed.</p>
              <button onClick={() => navigate("/discover")} className="btn-gold" data-testid="continue-btn">
                Continue
              </button>
            </>
          )}
          {state === "error" && (
            <>
              <div className="text-red-200/80 mb-4">{message}</div>
              <Link to="/login" className="btn-outline-gold inline-block">Back to sign in</Link>
            </>
          )}
        </div>
      </motion.div>
    </div>
  );
}
